module.exports = "<div class=\"ui padded grid\">\n  <div class=\"sixteen wide column\">\n    <h1>About this project.</h1>\n    <p>This page is a stub, so nothing useful for now.</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/about/template.html
// module id = 78
// module chunks = 0